import { Box, makeStyles, LabelValue, Typography } from '@dxb-web-ui-framework/design-system';
import React, { FC } from 'react';
import { TFunction } from 'react-i18next';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import { partiallyMaskValue } from '@dxb-web-ui-framework/common/utils/DataObfuscation';
import { PayrollDetails } from '../../domain/Payroll/entities/types';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },
  },
  boxContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    border: `2px solid ${theme.palette.background.default}`,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      backgroundColor: '#F0F0F0',
    },
  },
  labelValueWrapper: {
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(0),
    },
  },
}));

export interface TransactionsDetailsProps {
  t: TFunction;
  payrollDetails: Nullable<PayrollDetails>;
  isLoading: boolean;
}

const TransactionsDetails: FC<TransactionsDetailsProps> = ({ t, payrollDetails, isLoading }) => {
  const classes = useStyles();
  const { isExtraSmallScreen: isMobile } = useScreenDetector();

  return (
    <Box className={classes.root}>
      <Typography variant={'subtitle2'} color={'textPrimary'}>
        {t('payrollDetailsContent.transactionDetails')}
      </Typography>
      <Box p={2} className={classes.boxContainer}>
        {payrollDetails?.accountNumber && (
          <Box className={classes.labelValueWrapper}>
            <LabelValue
              label={t('payrollDetails.accountNumber')}
              value={partiallyMaskValue(payrollDetails.accountNumber.slice(-12), 6)}
              valueAreaLabel={`${t('payrollDetails.accountNumber')} ${partiallyMaskValue(
                payrollDetails.accountNumber.slice(-12),
                6,
              )}`}
              labelColor='textPrimary'
              labelSize='small'
              valueSize={isMobile ? 'small' : 'medium'}
              valueColor='primary'
              labelAlignment='left'
              valueAlignment='left'
              hasSkeleton={isLoading}
            />
          </Box>
        )}
        <Box className={classes.labelValueWrapper}>
          <LabelValue
            label={t('payrollDetails.fileName')}
            value={payrollDetails?.fileName}
            valueAreaLabel={`${t('payrollDetails.fileName')} ${payrollDetails?.fileName}`}
            labelColor='textPrimary'
            labelSize='small'
            valueSize={isMobile ? 'small' : 'medium'}
            valueColor='primary'
            labelAlignment='left'
            valueAlignment='left'
            hasSkeleton={isLoading}
          />
        </Box>
        <Box className={classes.labelValueWrapper}>
          <LabelValue
            label={t('payrollDetails.amount')}
            value={payrollDetails?.totalAmount}
            valueAreaLabel={`${t('payrollDetails.amount')} ${payrollDetails?.totalAmount}`}
            labelColor='textPrimary'
            labelSize='small'
            valueSize={isMobile ? 'small' : 'medium'}
            valueColor='primary'
            labelAlignment='left'
            valueAlignment='left'
            hasSkeleton={isLoading}
          />
        </Box>
      </Box>
    </Box>
  );
};

export { TransactionsDetails };
